const _defaultHandler = (propName, context) => (context ? context[propName] : undefined);
let _handler: any = _defaultHandler;

export function defaultDynamicPropertyHandler() {
  return _defaultHandler;
}
export function setDynamicPropertyHandler(handler) {
  _handler = handler;
  if (handler) {
    _handler._isUserDefined = true;
  }
}

export function DynamicPropertiesHandler() {
  return _handler;
}
